/* Shared refresh icon — swap shape here to update everywhere */
export default function RefreshIcon({ size = 14, style = {} }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display:'inline-block', verticalAlign:'middle', flexShrink:0, ...style }}
      aria-hidden="true"
    >
      <path d="M21 12a9 9 0 1 1-2.64-6.36"/>
      <path d="M21 4v4.5h-4.5"/>
    </svg>
  );
}
